import type { RootState } from 'state';
import type { RoutesFiltersState } from '../slice';

function getPage(state: RootState): RoutesFiltersState['page'] {
  const { page } = state.flightRoutes.filtersValues;
  return page;
}

export default getPage;
